import { Event } from '../global/event.js';
import { Bonus } from './bonus.js';

export class Products extends Event {
    constructor(mode) {
        super();
        this.bonusSelector = document.querySelectorAll('.bonusbox');
        this._holders = document.querySelectorAll('.bonuses');
        this._bonuse = [];
        this._nextCe = false;
        this._mode = mode;
        this.init();
    };
    
    get bonuses() {
        return this._bonuse;
    }

    init() {
        if(this._holders) {
            this._nextCe = this.nextCe(this._holders[this._holders.length-1]);
        }
        
        if(this.bonusSelector) {
            this.bonusSelector.forEach(product => {
                let element = new Bonus(product, this._mode);
                element.addEventListener('selectBonus', event => {
                    this.fireEvent(event.type, event.detail);
                    if(this._nextCe && this._mode == 'single') {
                        OVS.app.helper.scrollTo(this._nextCe);
                    }
                });
                element.addEventListener('unselectBonus', event => {
                    this.fireEvent(event.type, event.detail);
                });
                element.addEventListener('unselectBonuse', event => {
                    this.bonuses.forEach(element => {
                        if (this._mode == 'single' || (this._mode == 'multigroup' && event.detail.group == element.group)) {
                            element.unselect();
                        }
                    });
                });
                this._bonuse.push(element);
            });
        }
    };
    
    nextCe(query) {
        if (query) {
            let element = query.nextElementSibling;
            if(element) {
                if(element.classList.contains('divider-gray') || element.classList.contains('headline-border')) {
                    return this.nextCe(element);
                }
            }
            return element;
        }
    };
}
